import React from 'react';
import { Trash2, UserMinus } from 'react-feather';

interface RemoveAccountProps {
    can_delete_account: boolean; // aqui você define que post é do tipo Post
    onDelete: () => void; // Adicionado
}

const RemoveAccount: React.FC<RemoveAccountProps> = ({ onDelete, can_delete_account }) => {
    return (
        <>
            {can_delete_account ? (
                <li>
                    <ul className="ul-normal">
                        <span onClick={onDelete} className="dropdown-item cursor-pointer user-select-none">
                            <div className="div-icon-fix">
                                <><UserMinus data-feather="paperclip" data-type="unfix" className="icon-config-post"/>Excluir conta </>
                            </div>
                        </span>
                    </ul>
                </li>
            ) : null}
        </>
    );
};

export default RemoveAccount;
